module.exports = __webpack_public_path__ + "img/calendar_grey.0453637c.svg";